module.exports = __webpack_public_path__ + "img/right-active.c15e99fb.webp";